import React from 'react';
import { services } from '../data/services';

const Services: React.FC = () => {
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'CodeIcon':
        return (
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <polyline points="16,18 22,12 16,6"></polyline>
            <polyline points="8,6 2,12 8,18"></polyline>
          </svg>
        );
      case 'CloudIcon':
        return (
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
          </svg>
        );
      case 'MonitorIcon':
        return (
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
            <line x1="8" y1="21" x2="16" y2="21"></line>
            <line x1="12" y1="17" x2="12" y2="21"></line>
          </svg>
        );
      case 'NetworkIcon':
        return (
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
          </svg>
        );
      case 'ConsultingIcon':
        return (
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path d="M9 12l2 2 4-4"></path>
            <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"></path>
            <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3"></path>
            <path d="M12 3c0 1-1 3-3 3s-3-2-3-3 1-3 3-3 3 2 3 3"></path>
            <path d="M12 21c0-1 1-3 3-3s3 2 3 3-1 3-3 3-3-2-3-3"></path>
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <section id="services" className="py-20 bg-surface-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-ink-900">
            Our Services
          </h2>
          <p className="text-lg text-ink-500 max-w-2xl mx-auto">
            Comprehensive technology solutions tailored to your business needs
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            // Special behavior for SaaS Solutions
            if (service.id === 'saas-solutions') {
              return (
                <div
                  key={service.id}
                  className="glass-card p-8 text-center cursor-pointer hover:shadow-lg transition-shadow duration-300"
                  onClick={() => {
                    const avoSection = document.querySelector('#avo-ecosystem');
                    if (avoSection) {
                      avoSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                >
                  <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-gradient-to-r from-brand-start to-brand-end rounded-lg text-white">
                    {getIcon(service.icon)}
                  </div>
                  <h3 className="text-xl font-semibold mb-4 text-ink-900">
                    {service.title}
                  </h3>
                  <p className="text-ink-500 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              );
            }
            // Default card for other services
            return (
              <div key={service.id} className="glass-card p-8 text-center">
                <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-gradient-to-r from-brand-start to-brand-end rounded-lg text-white">
                  {getIcon(service.icon)}
                </div>
                <h3 className="text-xl font-semibold mb-4 text-ink-900">
                  {service.title}
                </h3>
                <p className="text-ink-500 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services; 